module.exports = __webpack_public_path__ + "img/programme2.5a805080.png";